import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-labelledby": "confirmModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog--small" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header d-flex justify-content-center" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "content mx-auto" }
const _hoisted_8 = { class: "text-center py-4" }
const _hoisted_9 = { class: "modal-footer d-flex justify-content-center" }

import { useRoute } from 'vue-router'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import communityAlumnusCandidates from '@/services/community-alumnus-candidates.services'
import { PropType } from 'vue'
import { Modal } from 'bootstrap'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
  handleShowError: Function as PropType<() => void | undefined>,
},
  setup(__props) {

const props = __props

const modalConfirm = ref()
const modalFinish = ref()
const loadingSubmit = ref<boolean>(false)

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('confirmModal'))
  modalFinish.value = new Modal(document.getElementById('modalEditSuccess'))
})
const route = useRoute()



const handleSubmit = async (): Promise<void> => {
  loadingSubmit.value = true
  try {
    const response = await communityAlumnusCandidates.updateAlumnusCandidateDetailApi({
      id: route.params?.id,
      management_no: route.query?.management_no,
      data: { examinated: props.data?.examinated },
    })
    if (response.status === 200) {
      props.handleShowError('success')
    } else if (response?.response?.status === 400) {
      // 2022/12/15 PhuongTT Fix for UAT Phase2#5646: CI40 (Ph2-R20221222)
      props.handleShowError(response?.response?.data?.data[0]?.message_code)
    } else {
      props.handleShowError('updateError')
    }
    loadingSubmit.value = false

    modalConfirm.value?.hide()
    modalFinish.value?.show()
  } catch (error) {
    props.handleShowError('updateError')
    console.log(error)
    loadingSubmit.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('confirmExaminationResult')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(__props.data?.family_name + ' ' + __props.data?.given_name) + "さん", 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(Button, {
            title: _unref(translate)('cancel'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            className: 'me-2'
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: _unref(translate)('update'),
            type: 'secondary',
            onClick: handleSubmit,
            loading: loadingSubmit.value,
            disabled: loadingSubmit.value
          }, null, 8, ["title", "loading", "disabled"])
        ])
      ])
    ])
  ]))
}
}

})